import { SettingsGroupCard, SettingsHubPage, SettingsNavItem } from '../settings-shared';
import { useSettingsIntegrationsStatus } from '../use-settings-integrations-status';

export function SettingsAccessPage() {
  const { ozonSubtitle, sellmonitorSubtitle, llmSubtitle } = useSettingsIntegrationsStatus();

  return (
    <SettingsHubPage title="Доступы">
      <SettingsGroupCard title="Подключения">
        <SettingsNavItem title="Ozon" subTitle={ozonSubtitle} to="/settings/ozon" />
        <SettingsNavItem title="Sellmonitor" subTitle={sellmonitorSubtitle} to="/settings/sellmonitor" />
        <SettingsNavItem title="AI" subTitle={llmSubtitle} to="/settings/ai" />
        <SettingsNavItem title="Промпты" subTitle="Шаблоны для модели" to="/settings/prompts" isLast />
      </SettingsGroupCard>
    </SettingsHubPage>
  );
}
